import {
    ALL_NOTIFICATIONS_FAIL,
    ALL_NOTIFICATIONS_REQUEST,
    ALL_NOTIFICATIONS_SUCCESS,
    CLEAR_ERRORS
} from "../constants/notificationConstants";

export const allNotificationsReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
        case ALL_NOTIFICATIONS_REQUEST:
            return {
                loading: true,
                notifications: [],
            };
        case ALL_NOTIFICATIONS_SUCCESS:
            return {
                loading: false,
                notifications: action.payload,
            };
        case ALL_NOTIFICATIONS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};
